import React from 'react';
import { Menu, MenuItem, Typography, Link } from '@mui/material';
import { useSession } from '../../providers/SessionProvider/SessionProvider';
import { useStyles } from './UserProfile.styles';
import { ConvertToPascalCase } from '../../utils/case-converter';

const UserProfile = () => {
  const { classes } = useStyles();
  const {
    firstName,
    lastName,
    email,
    isAuthenticated,
    logout,
    changeMFAMethod,
  } = useSession();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const showUserName = firstName && lastName;

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return isAuthenticated ? (
    <>
      <div className={classes.profilePanel} onClick={handleClick}>
        <div className={classes.avatar}>
          <span className={classes.avatarContent}>
            {showUserName
              ? firstName.charAt(0).toUpperCase() +
                lastName.charAt(0).toUpperCase()
              : email.charAt(0).toUpperCase()}
          </span>
        </div>
      </div>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem className={classes.infoPopup}>
          <div className={classes.largeAvatar}>
            <span className={classes.largeAvatarContent}>
              {showUserName
                ? firstName.charAt(0).toUpperCase() +
                  lastName.charAt(0).toUpperCase()
                : email.charAt(0).toUpperCase()}
            </span>
          </div>
          {showUserName && (
            <Typography variant="subtitle1">
              {ConvertToPascalCase(firstName)} {ConvertToPascalCase(lastName)}
            </Typography>
          )}
          <Typography variant="caption" className={classes.caption}>
            {email}
          </Typography>
        </MenuItem>
        <MenuItem className={classes.menuItem}>
          <Link href="#" variant="caption" 
            onClick={() => { 
              handleClose(); 
              changeMFAMethod(); 
            }}>
            Change MFA Method
          </Link>
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          onClick={() => {
            handleClose();
            logout();
          }}
        >
          Sign Out
        </MenuItem>
      </Menu>
    </>
  ) : null;
};

export default UserProfile;
